import React, { useCallback, useState, useEffect, useRef } from 'react';
import { Box, Typography, ListItem, ListItemText } from '@mui/material';
import CustomRowList from 'src/components/ui/list/custom-row-list';
import { getStatistic } from 'src/api/teachers/my-infor';
import HeaderCellText from 'src/components/ui/list/header-cell-text';

export const StatisticOverview = () => {
  const hasFetched = useRef(false);
  const [data, setData] = useState([]);

  const fetchData = useCallback(async () => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    const result = await getStatistic();
    setData(result);
  }, []);
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const renderItem = (item, rowstyle, index) => (
    <ListItem
      divider={true}
      key={index}
      sx={rowstyle}
    >
      <ListItemText sx={{ width: '26%', color: 'primary.main' }}>{item.month}</ListItemText>
      <ListItemText sx={{ width: '30%', textAlign: 'center' }}>{item.quantity}</ListItemText>
      <ListItemText sx={{ width: '26%', textAlign: 'center' }}>{item.distance}</ListItemText>
      <ListItemText sx={{ width: '18%', textAlign: 'right' }}>{item.hours}</ListItemText>
    </ListItem>
  );
  
  return (
    <Box component="main" sx={{ flexGrow: 1, py: 1, px: 0 }}>
      <CustomRowList
        items={data} 
        renderItem={renderItem}
      >
        <HeaderCellText sx={{ width: '26%' }}>
          Tháng
        </HeaderCellText>
        <HeaderCellText sx={{ width: '30%', textAlign: 'center' }}>
          Nhiên liệu
        </HeaderCellText>
        <HeaderCellText sx={{ width: '26%', textAlign: 'center' }}>
          Số Km
        </HeaderCellText>
        <HeaderCellText sx={{ width: '18%', textAlign: 'right' }}>
          Giờ lịch
        </HeaderCellText>
      </CustomRowList>
    </Box>
  );
};
